(function ($) {
  $(window).on("load", function () {
    // Rollo text animation

    const svgs = [
      `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.9961 4.93237C19.9727 4.71726 19.8391 4.52687 19.6393 4.43362L10.2643 0.058623C10.0967 -0.019541 9.9032 -0.019541 9.73566 0.058623L0.360664 4.43362C0.160898 4.52687 0.0272266 4.71722 0.00382812 4.93237C0.00332031 4.93686 0 4.99671 0 4.99999V15.625C0 15.8805 0.155586 16.1104 0.392891 16.2053L9.76789 19.9553C9.84238 19.9851 9.92121 20 10 20C10.0788 20 10.1576 19.9851 10.2321 19.9553L19.6071 16.2053C19.8444 16.1104 20 15.8805 20 15.625V4.99999C20 4.99671 19.9966 4.93683 19.9961 4.93237ZM10 1.31468L17.8025 4.95585L14.798 6.15765L6.84871 2.7853L10 1.31468ZM5.32461 3.49655L13.1506 6.81659L10 8.07683L2.1975 4.95585L5.32461 3.49655ZM1.25 5.92312L9.375 9.17312V18.4518L1.25 15.2018V5.92312ZM10.625 18.4519V9.17312L18.75 5.92312V15.2018L10.625 18.4519Z" fill="#97B6C0"/>
      </svg>`,
      `<svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.52344 8.20312H2.92969C2.60609 8.20312 2.34375 8.46547 2.34375 8.78906C2.34375 9.11266 2.60609 9.375 2.92969 9.375H6.52344C6.84703 9.375 7.10937 9.11266 7.10937 8.78906C7.10937 8.46547 6.84703 8.20312 6.52344 8.20312Z" fill="#97B6C0"/>
      <path d="M6.52344 10.5469H2.92969C2.60609 10.5469 2.34375 10.8092 2.34375 11.1328C2.34375 11.4564 2.60609 11.7188 2.92969 11.7188H6.52344C6.84703 11.7188 7.10937 11.4564 7.10937 11.1328C7.10937 10.8092 6.84703 10.5469 6.52344 10.5469Z" fill="#97B6C0"/>
      <path d="M17.6562 8.20609C17.6562 7.99691 17.6562 2.09887 17.6562 1.75781C17.6562 0.788555 16.8677 0 15.8984 0H1.75781C0.788555 0 0 0.788555 0 1.75781C0 2.17715 0 11.8492 0 12.3047C0 13.2739 0.788555 14.0625 1.75781 14.0625H8.39906C8.94344 16.7337 11.311 18.75 14.1406 18.75C17.3715 18.75 20 16.1215 20 12.8906C20 10.9777 19.0785 9.27617 17.6562 8.20609ZM1.17188 1.75781C1.17188 1.43473 1.43473 1.17188 1.75781 1.17188H15.8984C16.2215 1.17188 16.4844 1.43473 16.4844 1.75781V2.34375H1.17188V1.75781ZM1.17188 3.51562H16.4844V4.6875H1.17188V3.51562ZM8.28125 12.8906H1.75781C1.43473 12.8906 1.17188 12.6278 1.17188 12.3047V5.85938H16.4844V7.52102C15.7662 7.20633 14.9736 7.03125 14.1406 7.03125C10.9098 7.03125 8.28125 9.65977 8.28125 12.8906ZM14.1406 17.5781C11.5559 17.5781 9.45312 15.4753 9.45312 12.8906C9.45312 10.3059 11.5559 8.20312 14.1406 8.20312C16.7253 8.20312 18.8281 10.3059 18.8281 12.8906C18.8281 15.4753 16.7253 17.5781 14.1406 17.5781Z" fill="#97B6C0"/>
      <path d="M16.8987 11.3044C16.6699 11.0756 16.2989 11.0756 16.0701 11.3045L13.5547 13.8198L12.2112 12.4763C11.9824 12.2475 11.6114 12.2475 11.3826 12.4763C11.1537 12.7052 11.1537 13.0761 11.3826 13.305L13.1404 15.0628C13.2548 15.1772 13.4047 15.2344 13.5547 15.2344C13.7047 15.2344 13.8546 15.1772 13.969 15.0627L16.8987 12.1331C17.1275 11.9042 17.1275 11.5333 16.8987 11.3044Z" fill="#97B6C0"/>
      </svg>`,
      `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM10 18.1818C5.48848 18.1818 1.81818 14.5115 1.81818 10C1.81818 5.48855 5.48848 1.81818 10 1.81818C14.5115 1.81818 18.1818 5.48855 18.1818 10C18.1818 14.5115 14.5115 18.1818 10 18.1818Z" fill="#97B6C0"/>
      <path d="M13.7498 6.46448L8.60712 11.6071L6.25015 9.25006C5.89518 8.89509 5.31955 8.89503 4.96451 9.25C4.60948 9.60503 4.60948 10.1806 4.96451 10.5356L7.96427 13.5355C8.13476 13.706 8.36597 13.8018 8.60706 13.8018C8.60712 13.8018 8.60706 13.8018 8.60712 13.8018C8.84821 13.8018 9.07942 13.706 9.24991 13.5356L15.0354 7.75018C15.3905 7.39515 15.3905 6.81958 15.0354 6.46455C14.6804 6.10951 14.1048 6.10945 13.7498 6.46448Z" fill="#97B6C0"/>
      </svg>`,
    ];

    var rolodexes = document.querySelectorAll("[data-rolodex]");

    if (rolodexes) {
      for (var i = 0; i < rolodexes.length; i++) {
        var sentences = rolodexes[i].dataset.rolodex.split(".");

        setup(rolodexes[i], sentences);
      }

      // Create the additional text hidden from screen
      function setup(rolodex, sentences) {
        sentences.forEach(function (sentence, i) {
          //  console.log(sentence);
          if (sentence !== "") {
            var newNode = document.createElement("p");
            newNode.innerHTML += svgs[i];
            newNode.innerHTML += sentence.replace("+", ".");
            newNode.classList.add("next");
            rolodex.childNodes[
              rolodex.childNodes.length - 1
            ].parentNode.insertBefore(
              newNode,
              rolodex.childNodes[rolodex.childNodes.length - 1].nextSibling
            );
          }
        });

        rollText(rolodex);
      }

      // Roll the text
      function rollText(rolodex) {
        var count = 0;

        var roloItems = rolodex.querySelectorAll("p");
        // set rolodex parent item height to height of item TODO: set it to height of largest item
        //  let height = roloItems[0].offsetHeight;
        // rolodex.style.height = height + "px";

        setInterval(function () {
          var last = roloItems[count];
          last.classList.add("last");
          last.classList.remove("next");

          if (count >= roloItems.length - 1) {
            count = 0;
          } else {
            count++;
          }
          var current = roloItems[count];
          current.classList.remove("next");
          current.classList.remove("last");

          var next;
          if (count + 1 >= roloItems.length) {
            next = roloItems[0];
          } else {
            next = roloItems[count + 1];
          }
          next.classList.add("next");
          next.classList.remove("last");
        }, 3000);
      }
    }

    // Replace review widget text
    if ($(".jdgm-histogram__frequency").length) {
      $(".jdgm-histogram__frequency").each(function () {
        var thistext = $(this).text();
        thistext = thistext.replace("(", "").replace(")", "");
        $(this).text(thistext + " Reviews");
      });
    }

    // Get current month
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const currentDate = new Date();
    let currentMonth = months[currentDate.getMonth()];
    let targetMonth = document.querySelector(".currentMonth");

    if (targetMonth) {
      targetMonth.innerText = currentMonth;
    }

    if ($(".buynowbar").length) {
      var bnb = $(".buynowbar");
      var docHeight = $(document).height();
      var winHeight = $(window).innerHeight();
      $(window).on("scroll", function () {
        if (
          $(window).scrollTop() > 400 &&
          $(window).scrollTop() < docHeight - winHeight - 200
        ) {
          bnb.addClass("active");
        } else {
          bnb.removeClass("active");
        }
      });

      $(window).resize(function () {
        docHeight = $(document).height();
        winHeight = $(window).innerHeight();
      });
    }

    // Accordion for FAQs (jQuery)
    $(".accordion dt.active").next().slideDown();
    $(".accordion").on("click", "dt", function () {
      $(".accordion dd").slideUp();

      if (!$(this).hasClass("active")) {
        // remove active class from any others that might be active
        $(".accordion dt.active").removeClass("active");
        $(this).addClass("active");
        $(this).next().slideDown();
      } else {
        $(this).removeClass("active");
      }
    });

    $(".header-hamburger").click(function () {
      $("body").toggleClass("menu-open");
    });

    // Components loading animations
    $(".view-animation").viewportChecker({
      classToAdd: "animated",
      offset: 20,
    });

    // Lazyload
    $(".lazyload").Lazy({
      effect: "fadeIn",
      visibleOnly: true,
      onError: function (element) {
        console.log("error loading " + element.data("src"));
      },
    });

    // Mobile subnav opener
    $(".dropdown-trigger").click(function (e) {
      e.preventDefault();
      $(this).toggleClass("active");
      $(".sub-menu", $(this).closest("li")).toggleClass("active");
    });

    $(document).on("click", ".inline-video-trigger", function () {
      if ($(this).data("video-id")) {
        if ($(this).hasClass("vimeo")) {
          var iframeHTML =
            '<iframe src="https://player.vimeo.com/video/' +
            $(this).attr("data-video-id") +
            '?title=0&byline=0&portrait=0?&autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
        } else {
          var iframeHTML =
            '<iframe src="https://www.youtube.com/embed/' +
            $(this).attr("data-video-id") +
            '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
        }

        $(this)
          .parent(".video-preview-container")
          .find(".inline-video-trigger")
          .hide();
        $(this).parent(".video-preview-container").find(".overlay").hide();
        $(this).parent(".video-preview-container").find("iframe").remove();
        $(this).parent(".video-preview-container").append(iframeHTML);
      } else {
        console.error("no video ID provided.");
      }
    });

    // get all sliders, we need to loop them due to different settings + nav
    var swipers = document.querySelectorAll(
      ".swiper-container:not(.control):not(.mobile)"
    );
    window.wswipers = [];

    swipers.forEach(function (el, index) {
      var closestSection = el.closest("section");
      var controls = closestSection.querySelector(".control");

      // slider settings
      var options = {
        speed: 600,
        loop: true,
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        navigation: {},
        thumbs: {},
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1199: {
            slidesPerView: 3,
          },
        },
      };

      if (el.hasAttribute("data-slidestoshow")) {
        options.breakpoints = {
          992: {},
          1199: {},
        };
        options.breakpoints[992].slidesPerView = parseInt(
          el.getAttribute("data-slidestoshow")
        );
        options.breakpoints[1199].slidesPerView = parseInt(
          el.getAttribute("data-slidestoshow")
        );
      }

      if (el.hasAttribute("data-spacebetween")) {
        options.spaceBetween = 15;
        options.breakpoints[1199].spaceBetween = parseInt(
          el.getAttribute("data-spacebetween")
        );
      }

      if (el.hasAttribute("data-pagination")) {
        options.pagination = {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        };
      }

      if (el.hasAttribute("data-noloop")) {
        options.loop = false;
      }

      // init nav
      options.navigation = {
        nextEl: closestSection.querySelector(".swiper-next"),
        prevEl: closestSection.querySelector(".swiper-prev"),
      };

      // maybe add gallery controls to the slider

      if (controls) {
        options.thumbs.swiper = new Swiper(controls, {
          speed: 600,
          loop: false,
          slidesPerView: 8,
          spaceBetween: 0,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: true,
          },
        });
      }

      // init slider
      if (el.hasAttribute("id")) {
        window.wswipers[el.getAttribute("id")] = new Swiper(el, options);
      } else {
        new Swiper(el, options);
      }
    });

    // Mobile Product Swiper
    var swipers = document.querySelectorAll(".swiper-container.mob-gallery");
    window.wswipers = [];

    swipers.forEach(function (el, index) {
      var closestSection = el.closest("section");
      var controls = closestSection.querySelector(".control.mob-control");

      // slider settings
      var options = {
        speed: 600,
        loop: true,
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        navigation: {},
        thumbs: {},
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1199: {
            slidesPerView: 3,
          },
        },
      };

      if (el.hasAttribute("data-slidestoshow")) {
        options.breakpoints = {
          992: {},
          1199: {},
        };
        options.breakpoints[992].slidesPerView = parseInt(
          el.getAttribute("data-slidestoshow")
        );
        options.breakpoints[1199].slidesPerView = parseInt(
          el.getAttribute("data-slidestoshow")
        );
      }

      if (el.hasAttribute("data-spacebetween")) {
        options.spaceBetween = 15;
        options.breakpoints[1199].spaceBetween = parseInt(
          el.getAttribute("data-spacebetween")
        );
      }

      if (el.hasAttribute("data-pagination")) {
        options.pagination = {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        };
      }

      if (el.hasAttribute("data-noloop")) {
        options.loop = false;
      }

      // init nav
      options.navigation = {
        nextEl: closestSection.querySelector(".swiper-next"),
        prevEl: closestSection.querySelector(".swiper-prev"),
      };

      // maybe add gallery controls to the slider

      if (controls) {
        options.thumbs.swiper = new Swiper(controls, {
          speed: 800,
          loop: false,
          slidesPerView: 8,
          spaceBetween: 0,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: true,
          },
        });
      }

      // init slider
      if (el.hasAttribute("id")) {
        window.wswipers[el.getAttribute("id")] = new Swiper(el, options);
      } else {
        new Swiper(el, options);
      }
    });

    // mobile sliders, like logo rows etc
    // need to loop in order to get the slide count
    var mobileSwipers = document.querySelectorAll(".swiper-container.mobile");
    mobileSwipers.forEach(function (el, index) {
      var closestSection = el.closest("section") || el.closest("header");
      var slideCount = el.querySelectorAll(".swiper-slide").length;

      var options = {
        speed: 1400,
        slidesPerView: 1,
        watchOverflow: true,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: true,
        },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        breakpoints: {
          576: {
            slidesPerView: 1,
          },
          992: {
            slidesPerView: 2,
          },
          1280: {
            slidesPerView: 3,
          },
        },
      };

      if (el.classList.contains("gallery-sub")) {
        options.breakpoints = {};
        options.speed = 600;
      }

      // init nav
      options.navigation = {
        nextEl: closestSection.querySelector(".swiper-next"),
        prevEl: closestSection.querySelector(".swiper-prev"),
      };

      if (el.hasAttribute("data-spacebetween")) {
        options.spaceBetween = 15;
        options.breakpoints[1280].spaceBetween = parseInt(
          el.getAttribute("data-spacebetween")
        );
      }

      if (el.hasAttribute("data-slidestoshow")) {
        options.breakpoints = {
          992: {},
          1199: {},
        };
        options.breakpoints[992].slidesPerView = parseInt(
          el.getAttribute("data-slidestoshow")
        );
        options.breakpoints[1199].slidesPerView = parseInt(
          el.getAttribute("data-slidestoshow")
        );
      }

      // init slider
      new Swiper(el, options);
    });

    // Phone Concatenation Script For Tracking
    setTimeout(function () {
      $(".phone-text em").each(function () {
        var unsliced = $(this).text();
        var sliced = unsliced.slice(0, -2) + "...";
        $(this).text(sliced);
        var linked = "tel:" + unsliced.replace(/\s/g, "");
        $(this).click(function () {
          if ($(window).width() < 1000) {
            window.location.href = linked;
          } else {
            $(this).text(unsliced);
          }
        });
      });
    }, 3000);

    if ($("#timer").length) {
      var timeduration = $(".announcements").data("duration");
      var timetype = $(".announcements").data("type");
      startTimer(timeduration, timetype, $("#timer")[0]);
    }
  });

  // Refresh page when clicking back
  var perfEntries = performance.getEntriesByType("navigation");

  if (perfEntries[0].type === "back_forward") {
    location.reload(true);
  }

  // Sticky Header
  responsiveAnnouncementBar();
  $(window).on("scroll load", function () {
    if ($(window).scrollTop() >= 50) {
      $("header").addClass("scrolled");
    } else {
      $("header").removeClass("scrolled");
    }
  });

  // Smooth Scroll To Anchor
  $(document).on("click", ".js-cta", function () {
    target = $(this).attr("data-target");

    if (target.length) {
      $("html, body").animate(
        {
          scrollTop: $(target).find("form").offset().top,
        },
        1500
      );
    }
  });

  var resizeTimer;
  $(window).bind("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      responsiveAnnouncementBar();
    }, 100);
  });

  function responsiveAnnouncementBar() {
    // announcement bar can be of varying height due to content, especially mobile
    // this just creates css for the fixed header so the offset values are correct
    var anbarHeight = $(".announcements").outerHeight();
    var headerHeight = $(".site-header").outerHeight();
    var headerStyleDiv = $("#header-styles");

    var newStyles =
      "" +
      "body.fixed-header.has-announcements .site-header.scrolled," +
      "body.fixed-header .site-header.hide-announcements{" +
      "transform: translateY(-" +
      anbarHeight +
      "px);" +
      "}";

    newStyles +=
      "" +
      "body.fixed-header.has-announcements {" +
      "padding-top: " +
      headerHeight +
      "px;" +
      "}";

    headerStyleDiv.html(newStyles);
  }

  // Exit intent
  var hasOpenedModal = false;
  if (!getCookie("nlpopup-" + window.sitename)) {
    setTimeout(function () {
      document.addEventListener("mouseout", function (evt) {
        if (
          !evt.toElement &&
          !evt.relatedTarget &&
          !hasOpenedModal &&
          !$("#prescribeForm").hasClass("show")
        ) {
          $("#newsletterForm").modal(true);
          hasOpenedModal = true;
          setCookie("nlpopup-" + window.sitename, true, 1);
        }
      });
    }, 3000);
  }
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  // Countdown timer
  function startTimer(duration, type, display) {
    var timer = duration;
    var minutes, seconds, hours, days;
    var now = Math.floor(Date.now() / 1000);

    if (type == "evergreen") {
      var nearestblock = Math.ceil(now / (duration * 60)) * (duration * 60);
      timer = nearestblock - now;
    }

    if (type == "to_date") {
      var dateparts = duration.split(" ")[0];
      var timeparts = duration.split(" ")[1];

      // we need to 0 index the month
      var datestring =
        dateparts[0] + "-" + (dateparts[1] - 1) + "-" + dateparts[2] + " ";
      datestring += timeparts;
      var todate = Date.parse(duration) / 1000;
      timer = todate - now;
    }

    setInterval(function () {
      minutes = parseInt(timer / 60, 10) % 60;
      seconds = parseInt(timer % 60, 10);

      hours = parseInt(timer / 60 / 60, 10) % 24;
      days = parseInt(timer / 60 / 60 / 24, 10);

      days = days < 10 ? "0" + days : days;
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      if (days > 0) {
        display.textContent = `${hours}H ${minutes}M`;
      } else {
        display.textContent = `${hours}H ${minutes}M`;
      }

      if (--timer < 0) {
        timer = 0;
        hideBar();
      }
    }, 1000);

    function hideBar() {
      if ($(".announcements").hasClass("hide-after-time")) {
        $("body").removeClass("has-announcements");
        $(".main-header").addClass("hide-announcements");
      }
    }
  }
})(jQuery);

// Video Pop-up in product page
$(document).ready(function () {
  // Gets the video src from the data-src on each button
  var $videoSrc;
  $(".video-btn").click(function () {
    $videoSrc = $(this).data("src");
  });

  // when the modal is opened autoplay it
  $("#myModal").on("shown.bs.modal", function (e) {
    // set the video src to autoplay and not to show related video. Youtube related video is like a box of chocolates... you never know what you're gonna get
    $("#video").attr("src", $videoSrc + "?badge=0");
  });

  // stop playing the youtube video when I close the modal
  $("#myModal").on("hidden.bs.modal", function (e) {
    // a poor man's stop video
    $("#video").attr("src", "");
  });

  // document ready

  kk_set_bold_title();
});

function kk_set_bold_title() {
  const checkTitle = () => {
    if (typeof window.BOLD != "undefined") {
      var $title = $("#prod_id_7616448299261_0 .bold-product__title");
      var money = document.querySelector(
        ".bold-product__price.additional_price .money"
      );
      var addBtns = document.querySelectorAll(
        "[data-bold-component-id].add-to-cart.bold-product__control"
      );
      if ($title.length) {
        $title.text("Mat");
        clearInterval(checker);
      }
      if (money) {
        let oldValue = parseFloat(money.innerText.replace("$", ""));
        money.innerText = `$${Math.ceil(oldValue)}`;
      }
      if (addBtns) {
        addBtns.forEach((el) => (el.title = ""));
      }
    }
  };

  let checker = setInterval(checkTitle, 500);
}
